/** Replaces a zero amount (e.g. '0円', '0USD') with '- <unit>' for display. */
export const formatZeroAmount = (
  amount?: string | null
): string | undefined | null => amount?.replace(/^0(?![.,\d])/, '- ') ?? amount;
